(function($) {

    var Swiper = require("swiper/dist/js/swiper"),
        init = function() {
            return initMySwiper(),
                   initSwiperGallery(),
                   initThumbsGallery();
        },
        initMySwiper = function() {
            if( ! $('.filter-slider').length )
            {
                return;
            }

            let mySwiper = new Swiper('.filter-slider', {
                speed: 400,
                centeredSlides: true,
                loop: true,
                slidesPerView: 3.8,
                breakpoints: {
                    769: {
                        slidesPerView: 1.2
                    },
                    1240: {
                        slidesPerView: 2.1
                    }
                }
            });
        },
        initSwiperGallery = function() {
            if( ! $('.swiper-container#gallery').length )
            {
                return;
            }

            let swiperGallery = new Swiper('.swiper-container#gallery', {
                speed: 1000,
                parallax: true,
                watchSlidesProgress: true,
                slidesPerView: 1.5,
                lazy: {
                    loadPrevNext: true,
                },
                navigation: {
                    nextEl: '.swiper-button-top-next',
                    prevEl: '.swiper-button-top-prev',
                },
                pagination: {
                    el: '.swiper_pagination',
                    type: 'fraction',
                },
                breakpoints: {
                    769: {
                        slidesPerView: 1
                    }
                }
            });
        };
        initThumbsGallery = function() {
            if( ! $('.swiper-container.gallery-thumbs').length )
            {
                return;
            }

            var galleryThumbs = new Swiper('.gallery-thumbs', {
                spaceBetween: 10,
                slidesPerView: 6,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            var galleryTop = new Swiper('.gallery-top', {
                spaceBetween: 10,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: galleryThumbs
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                }
            });
        }

    $(document).ready(init);
})(jQuery);